// extracted by mini-css-extract-plugin
export var buyButton = "nav-module--buyButton--6af43";
export var buyButtons = "nav-module--buyButtons--b12ad";
export var logo = "nav-module--logo--6e027";
export var mask = "nav-module--mask--bc12a";
export var menuButton = "nav-module--menuButton--6ffd9";
export var mobile = "nav-module--mobile--d46cb";
export var mobileList = "nav-module--mobileList--2bf17";
export var nav = "nav-module--nav--b7415";
export var open = "nav-module--open--0cbc3";
export var right = "nav-module--right--b7f39";
export var visible = "nav-module--visible--cc3e6";